export default __webpack_public_path__ + "static/media/GustavDustParticleBackLeft.ac09f908.png";